import React from "react";

interface NotificationBellIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const NotificationBellIcon: React.FC<NotificationBellIconProps> = ({
  width = 34,
  height = 34,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      className={className}
    >
      <path
        d="M16.3 27C16.4674 27.3044 16.7135 27.5583 17.0125 27.7352C17.3116 27.912 17.6526 28.0053 18 28.0053C18.3475 28.0053 18.6885 27.912 18.9876 27.7352C19.2866 27.5583 19.5327 27.3044 19.7 27M12 14C12 12.4087 12.6321 10.8826 13.7574 9.75736C14.8826 8.63214 16.4087 8 18 8C19.5913 8 21.1174 8.63214 22.2426 9.75736C23.3679 10.8826 24 12.4087 24 14C24 21 27 23 27 23H9C9 23 12 21 12 14Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NotificationBellIcon;
